module.exports = __webpack_public_path__ + "static/media/PoidsLivraison.1dd7792c.svg";